<template>
    <div class="mt-10 mb-7 w-full flex flex-row justify-start items-center">
        <div
            class="mr-4 cursor-pointer w-7 h-7 flex items-center justify-center 
              rounded-full bg-black bg-opacity-0 hover:bg-opacity-10"
            @click="$router.push({ name: 'Dashboard' })"
        >
            <back-icon v-if="hasBack" :fillClass="'fill-primary'" />
        </div>
        <h1 class="text-black font-semibold text-3xl">{{ title }}</h1>
    </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "Header",
    props: {
        title: { type: String, required: true },
        hasBack: { type: Boolean, default: true },
    },
    components: {},
    setup() {},
});
</script>
